// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"494":"3f43af8b","563":"deadbbfa","720":"119d3c38","787":"c5fb6c1c"}[chunkId] + ".chunk.js";
};